<div class="p-4 w-[33vw]">
  <h2 class="text-center" matDialogTitle>Veuillez vous authentifier</h2>
  <app-login-form></app-login-form>
</div>
